'use client'

import { useCallback, useState } from 'react'
import { useNotification } from './useNotification'
import { uploadAvatarFile } from '@/helpers/uploadAvatarFile'
import { logger } from '@/lib'
import { useSeasonOrganization } from '@/hooks/useSeasonOrganization'
import { NotificationType } from '@/components/ui'

export const useUploadFbPostImage = () => {
  const [loading, setLoading] = useState(false)
  const { seasonOrganization } = useSeasonOrganization()
  const { openNotification } = useNotification()

  const uploadFbPostImage = useCallback(
    async ({ blob }: { blob: Blob }) => {
      setLoading(true)

      try {
        const [err, [uploadResult]] = await uploadAvatarFile(blob, String(seasonOrganization?.organizationId))

        if (err) {
          openNotification('Fail to load file', NotificationType.ERROR)
          logger.error(err)
          return null
        }

        return uploadResult
      } catch (error) {
        logger.error(error)
      } finally {
        setLoading(false)
      }
    },
    [openNotification, seasonOrganization],
  )

  return { uploadFbPostImage, loading }
}
